export const getPercentOffFigure: Function = (monthlyAmount: number, yearlyAmount: number): number => {
	if (!yearlyAmount || yearlyAmount <= 0) return 0;
	const monthlyToYearly: number = (monthlyAmount || 0) * 12;
	if (monthlyToYearly <= 0) return 0;
	return Math.round(((monthlyToYearly - yearlyAmount) / monthlyToYearly) * 100);
};
